import { motion } from 'framer-motion6';
import styled from 'styled-components';
import { sizes } from 'style';

export const CardsContainer = styled(motion.div)`
  display: flex;
  min-width: min-content;
  padding-left: 0px;

  @media ${sizes.mobileLarge} {
    padding-left: 20px;
  }

  @media ${sizes.desktop} {
    display: none;
  }
`;
